export const qpxDropbox = `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
    <path
        fill="#0061ff"
        d="M7 4 2 7.185l5 3.186 5-3.186zm10 0-5 3.186 5 3.185 5-3.185zM2 13.556l5 3.186 5-3.186-5-3.185zm15-3.185-5 3.186 5 3.185 5-3.185zm-10 7.44 5 3.185 5-3.186-5-3.185z"
    />
</svg>`;

export const qpxGoogleDrive = `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
    <path
        fill="#34a853"
        d="M12 8.858 8.852 3.306a1 1 0 0 1 .346-.223c-.929.305-1.355 1.347-1.355 1.347L2.096 14.573c-.081.318-.104.604-.094.857h6.275z"
    />
    <path
        fill="#fbbc05"
        d="m12 8.858 3.724 6.572h6.274c.01-.289-.02-.578-.093-.858l-5.75-10.143s-.427-1.042-1.353-1.347a1 1 0 0 1 .345.223z"
    />
    <path
        fill="#188038"
        d="m12 8.859 3.146-5.553a1 1 0 0 0-.343-.224A1.8 1.8 0 0 0 14.358 3H9.641a1.6 1.6 0 0 0-.443.082 1 1 0 0 0-.345.224z"
    />
    <path
        fill="#4285f4"
        d="m8.277 15.43-3.11 5.492s-.104-.051-.244-.155c.441.34.87.412.87.412h12.219c.674 0 .814-.257.814-.257l.006-.004-3.11-5.488z"
    />
    <path
        fill="#1967d2"
        d="M8.278 15.43H2.003c.031.746.355 1.182.355 1.182l.236.41.028.038.512.9 1.153 2.008a2 2 0 0 0 .162.299l.014.02c.142.202.302.357.46.48.142.105.245.155.245.155z"
    />
    <path
        fill="#ea4335"
        d="M15.724 15.43h6.274c-.031.746-.355 1.182-.355 1.182l-.236.41-.027.038-.513.9-1.153 2.008q-.051.12-.114.226l-.047.073-.014.02a2.2 2.2 0 0 1-.462.48c-.14.105-.244.155-.244.155z"
    />
</svg>`;

export const qpxOneDrive = `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
        d="M7.07983 6.6073C3.71638 6.60738 1.20224 9.3606 1.01297 12.4277C1.13014 13.0886 1.51524 14.3936 2.11832 14.3266C2.87217 14.2428 4.77076 14.3266 6.39014 11.3949C7.5731 9.25337 10.0065 6.60723 7.07983 6.6073Z"
        fill="url(#paint0_radial_3_87)"
    />
    <path
        d="M6.30211 7.75192C5.17153 9.54196 3.64966 12.1069 3.13603 12.914C2.52548 13.8734 0.908542 13.4659 1.04249 12.0906C1.02929 12.2023 1.01997 12.3144 1.01297 12.4277C0.791783 16.0056 3.62774 18.9774 7.15776 18.9774C11.0483 18.9774 20.327 14.1298 19.388 9.27286C18.3983 6.41783 15.6165 4.37006 12.4639 4.37006C9.31138 4.37006 7.29092 6.18632 6.30211 7.75192Z"
        fill="url(#paint1_radial_3_87)"
    />
    <path
        d="M6.30211 7.75192C5.17153 9.54196 3.64966 12.1069 3.13603 12.914C2.52548 13.8734 0.908542 13.4659 1.04249 12.0906C1.02929 12.2023 1.01997 12.3144 1.01297 12.4277C0.791783 16.0056 3.62774 18.9774 7.15776 18.9774C11.0483 18.9774 20.327 14.1298 19.388 9.27286C18.3983 6.41783 15.6165 4.37006 12.4639 4.37006C9.31138 4.37006 7.29092 6.18632 6.30211 7.75192Z"
        fill="url(#paint2_radial_3_87)"
        fill-opacity="0.4"
    />
    <path
        d="M6.30211 7.75192C5.17153 9.54196 3.64966 12.1069 3.13603 12.914C2.52548 13.8734 0.908542 13.4659 1.04249 12.0906C1.02929 12.2023 1.01997 12.3144 1.01297 12.4277C0.791783 16.0056 3.62774 18.9774 7.15776 18.9774C11.0483 18.9774 20.327 14.1298 19.388 9.27286C18.3983 6.41783 15.6165 4.37006 12.4639 4.37006C9.31138 4.37006 7.29092 6.18632 6.30211 7.75192Z"
        fill="url(#paint3_radial_3_87)"
    />
    <path
        d="M6.30211 7.75192C5.17153 9.54196 3.64966 12.1069 3.13603 12.914C2.52548 13.8734 0.908542 13.4659 1.04249 12.0906C1.02929 12.2023 1.01997 12.3144 1.01297 12.4277C0.791783 16.0056 3.62774 18.9774 7.15776 18.9774C11.0483 18.9774 20.327 14.1298 19.388 9.27286C18.3983 6.41783 15.6165 4.37006 12.4639 4.37006C9.31138 4.37006 7.29092 6.18632 6.30211 7.75192Z"
        fill="url(#paint4_radial_3_87)"
        fill-opacity="0.6"
    />
    <path
        d="M6.30211 7.75192C5.17153 9.54196 3.64966 12.1069 3.13603 12.914C2.52548 13.8734 0.908542 13.4659 1.04249 12.0906C1.02929 12.2023 1.01997 12.3144 1.01297 12.4277C0.791783 16.0056 3.62774 18.9774 7.15776 18.9774C11.0483 18.9774 20.327 14.1298 19.388 9.27286C18.3983 6.41783 15.6165 4.37006 12.4639 4.37006C9.31138 4.37006 7.29092 6.18632 6.30211 7.75192Z"
        fill="url(#paint5_radial_3_87)"
        fill-opacity="0.9"
    />
    <path
        d="M7.10098 18.9786C7.10098 18.9786 16.3906 18.9969 17.9663 18.9969C20.8259 18.9969 23.0001 16.6623 23.0001 13.9381C23.0001 11.2139 20.7823 8.89343 17.9664 8.89343C15.1504 8.89343 13.5288 11.0001 12.3109 13.2996C10.8836 15.9942 9.06298 18.9463 7.10098 18.9786Z"
        fill="url(#paint6_linear_3_87)"
    />
    <path
        d="M7.10098 18.9786C7.10098 18.9786 16.3906 18.9969 17.9663 18.9969C20.8259 18.9969 23.0001 16.6623 23.0001 13.9381C23.0001 11.2139 20.7823 8.89343 17.9664 8.89343C15.1504 8.89343 13.5288 11.0001 12.3109 13.2996C10.8836 15.9942 9.06298 18.9463 7.10098 18.9786Z"
        fill="url(#paint7_radial_3_87)"
        fill-opacity="0.4"
    />
    <path
        d="M7.10098 18.9786C7.10098 18.9786 16.3906 18.9969 17.9663 18.9969C20.8259 18.9969 23.0001 16.6623 23.0001 13.9381C23.0001 11.2139 20.7823 8.89343 17.9664 8.89343C15.1504 8.89343 13.5288 11.0001 12.3109 13.2996C10.8836 15.9942 9.06298 18.9463 7.10098 18.9786Z"
        fill="url(#paint8_radial_3_87)"
        fill-opacity="0.9"
    />
    <defs>
        <radialGradient
            id="paint0_radial_3_87"
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(1.43007 7.41116) rotate(50.1526) scale(6.93403 11.5014)"
        >
            <stop stop-color="#4894FE" />
            <stop offset="0.695072" stop-color="#0934B3" />
        </radialGradient>
        <radialGradient
            id="paint1_radial_3_87"
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(20.0448 -0.572534) rotate(130.923) scale(29.817 22.0946)"
        >
            <stop offset="0.165327" stop-color="#23C0FE" />
            <stop offset="0.534" stop-color="#1C91FF" />
        </radialGradient>
        <radialGradient
            id="paint2_radial_3_87"
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(5.92949 7.80565) rotate(-139.986) scale(6.06208 13.8774)"
        >
            <stop stop-color="white" />
            <stop offset="0.660528" stop-color="#ADC0FF" stop-opacity="0" />
        </radialGradient>
        <radialGradient
            id="paint3_radial_3_87"
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(12.5213 14.9706) rotate(-139.764) scale(6.83283 10.3772)"
        >
            <stop stop-color="#033ACC" />
            <stop offset="1" stop-color="#368EFF" stop-opacity="0" />
        </radialGradient>
        <radialGradient
            id="paint4_radial_3_87"
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(5.52825 3.90792) rotate(66.5713) scale(14.9928 16.1856)"
        >
            <stop offset="0.592618" stop-color="#3464E3" stop-opacity="0" />
            <stop offset="1" stop-color="#033ACC" />
        </radialGradient>
        <radialGradient
            id="paint5_radial_3_87"
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(19.8044 0.984609) rotate(135) scale(22.054 34.5511)"
        >
            <stop stop-color="#4BFDE8" />
            <stop offset="0.543937" stop-color="#4BFDE8" stop-opacity="0" />
        </radialGradient>
        <linearGradient
            id="paint6_linear_3_87"
            x1="15.0554"
            y1="18.9867"
            x2="15.0554"
            y2="9.01327"
            gradientUnits="userSpaceOnUse"
        >
            <stop stop-color="#0086FF" />
            <stop offset="0.49" stop-color="#00BBFF" />
        </linearGradient>
        <radialGradient
            id="paint7_radial_3_87"
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(9.8438 10.0817) rotate(21.6324) scale(9.99348 18.9243)"
        >
            <stop stop-color="white" />
            <stop offset="0.785262" stop-color="white" stop-opacity="0" />
        </radialGradient>
        <radialGradient
            id="paint8_radial_3_87"
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(22.6892 8.11035) rotate(139.243) scale(13.7008 13.7473)"
        >
            <stop stop-color="#4BFDE8" />
            <stop offset="0.584724" stop-color="#4BFDE8" stop-opacity="0" />
        </radialGradient>
    </defs>
</svg>`;

export const qpxProcore = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="-149 -141 1789 1690">
    <path d="M1311.3 18.5c36.3 13.8 69.3 35.1 96.8 62.4 27.5 27.4 49 60.2 63.1 96.4 14.1 36.1 20.5 74.9 18.7 113.6v226h-338l-147.2-254H486.4L230.3 705.6l250.9 442.7h518.3l147.2-254h338v226c1.3 38-5.2 75.9-19.2 111.4-14 35.4-35.1 67.6-62 94.5-27 26.9-59.1 48-94.6 62-35.4 14-73.3 20.5-111.4 19.2H289.4c-38.1 1.3-76.1-5.2-111.5-19.2-35.5-13.9-67.8-35-94.8-61.9-27-27-48.2-59.1-62.3-94.5-14.1-35.5-20.7-73.4-19.6-111.5V290.9C-.4 252.6 6 214.3 19.9 178.5s35-68.4 62.1-95.6c27-27.3 59.4-48.6 95.1-62.8C212.8 6 251-.7 289.4.7h908.1c38.8-2.1 77.6 4 113.8 17.8" />
    <path
        fill="#ff5200"
        d="M607.7 473.4h269.5L1012 705.6 877.2 937.8H607.7L472.9 705.6z"
    />
</svg>`;

export const qpxSharepoint = `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
    <path fill="url(#a)" d="M10 14a6 6 0 1 0 0-12.002A6 6 0 0 0 10 14" />
    <path
        fill="url(#b)"
        fill-opacity=".2"
        d="M10 14a6 6 0 1 0 0-12.002A6 6 0 0 0 10 14"
    />
    <path
        fill="url(#c)"
        fill-opacity=".31"
        d="M10 14a6 6 0 1 0 0-12.002A6 6 0 0 0 10 14"
    />
    <path
        fill="url(#d)"
        fill-opacity=".7"
        d="M10 14a6 6 0 1 0 0-12.002A6 6 0 0 0 10 14"
    />
    <path fill="url(#e)" d="M16 18a5 5 0 1 0-5-5v5z" />
    <path fill="url(#f)" fill-opacity=".5" d="M16 18a5 5 0 1 0-5-5v5z" />
    <path fill="url(#g)" fill-opacity=".7" d="M16 18a5 5 0 1 0-5-5v5z" />
    <path
        fill="url(#h)"
        d="M10.867 22a4.167 4.167 0 1 0 .13-8.332 4.167 4.167 0 0 0-.13 8.332"
    />
    <path
        fill="url(#i)"
        fill-opacity=".32"
        d="M10.867 22a4.167 4.167 0 1 0 .13-8.332 4.167 4.167 0 0 0-.13 8.332"
    />
    <path
        fill="url(#j)"
        d="M9 10H4a2 2 0 0 0-2 2v5a2 2 0 0 0 2 2h5a2 2 0 0 0 2-2v-5a2 2 0 0 0-2-2"
    />
    <path
        fill="url(#k)"
        fill-opacity=".6"
        d="M9 10H4a2 2 0 0 0-2 2v5a2 2 0 0 0 2 2h5a2 2 0 0 0 2-2v-5a2 2 0 0 0-2-2"
    />
    <path
        fill="#fff"
        d="m4.616 16.017.948-.495a1.1 1.1 0 0 0 .418.477q.262.154.572.154.346 0 .526-.14.182-.143.182-.428a.48.48 0 0 0-.175-.377q-.173-.158-.617-.237-.843-.153-1.227-.537a1.3 1.3 0 0 1-.38-.955q0-.711.502-1.137.502-.425 1.325-.425.555 0 .976.227.42.226.67.648l-.928.478a1.04 1.04 0 0 0-.331-.342.85.85 0 0 0-.446-.108q-.321 0-.488.14a.45.45 0 0 0-.164.362q0 .192.157.338.16.143.641.234.81.153 1.206.558.402.4.401 1.014 0 .746-.477 1.182-.478.435-1.363.436-.642 0-1.158-.28a1.84 1.84 0 0 1-.77-.787"
    />
    <defs>
        <radialGradient
            id="b"
            cx="0"
            cy="0"
            r="1"
            gradientTransform="rotate(247.552 11.155 3.872)scale(9.21304 16.5645)"
            gradientUnits="userSpaceOnUse"
        >
            <stop offset=".286" stop-color="#003b5d" />
            <stop offset=".612" stop-color="#004a6c" stop-opacity=".688" />
            <stop offset=".968" stop-color="#006f94" stop-opacity="0" />
        </radialGradient>
        <radialGradient
            id="c"
            cx="0"
            cy="0"
            r="1"
            gradientTransform="rotate(247.937 10.407 2.448)scale(7.77595 13.9636)"
            gradientUnits="userSpaceOnUse"
        >
            <stop offset=".26" stop-color="#002a42" />
            <stop offset=".612" stop-color="#004261" stop-opacity=".688" />
            <stop offset=".968" stop-color="#006f94" stop-opacity="0" />
        </radialGradient>
        <radialGradient
            id="d"
            cx="0"
            cy="0"
            r="1"
            gradientTransform="rotate(124.447 6.018 4.853)scale(6.50536)"
            gradientUnits="userSpaceOnUse"
        >
            <stop stop-color="#78edff" />
            <stop offset="1" stop-color="#2ccfca" stop-opacity="0" />
        </radialGradient>
        <radialGradient
            id="f"
            cx="0"
            cy="0"
            r="1"
            gradientTransform="rotate(-70.801 18.645 -.658)scale(6.17687 11.1294)"
            gradientUnits="userSpaceOnUse"
        >
            <stop stop-color="#004a5d" />
            <stop offset=".492" stop-color="#00556c" stop-opacity=".688" />
            <stop offset=".968" stop-color="#007a86" stop-opacity="0" />
        </radialGradient>
        <radialGradient
            id="g"
            cx="0"
            cy="0"
            r="1"
            gradientTransform="rotate(124.447 7.18 9.23)scale(5.42114)"
            gradientUnits="userSpaceOnUse"
        >
            <stop stop-color="#78edff" />
            <stop offset="1" stop-color="#2ccfca" stop-opacity="0" />
        </radialGradient>
        <radialGradient
            id="j"
            cx="0"
            cy="0"
            r="1"
            gradientTransform="rotate(45 -11.071 7.414)scale(12.7279)"
            gradientUnits="userSpaceOnUse"
        >
            <stop offset=".063" stop-color="#00b6bd" />
            <stop offset=".89" stop-color="#00495c" />
        </radialGradient>
        <radialGradient
            id="k"
            cx="0"
            cy="0"
            r="1"
            gradientTransform="matrix(0 6.3 -7.17187 0 6.5 15.4)"
            gradientUnits="userSpaceOnUse"
        >
            <stop offset=".567" stop-color="#1e8581" stop-opacity="0" />
            <stop offset=".974" stop-color="#1ecbe6" />
        </radialGradient>
        <linearGradient
            id="a"
            x1="5.5"
            x2="13.5"
            y1="3.5"
            y2="14"
            gradientUnits="userSpaceOnUse"
        >
            <stop stop-color="#00e3df" />
            <stop offset=".41" stop-color="#0097a8" />
            <stop offset="1" stop-color="#007791" />
        </linearGradient>
        <linearGradient
            id="e"
            x1="12.25"
            x2="18.917"
            y1="9.25"
            y2="18"
            gradientUnits="userSpaceOnUse"
        >
            <stop stop-color="#00e0d9" />
            <stop offset=".476" stop-color="#009fb8" />
            <stop offset=".945" stop-color="#056475" />
        </linearGradient>
        <linearGradient
            id="h"
            x1="7.95"
            x2="12.117"
            y1="14.083"
            y2="22.417"
            gradientUnits="userSpaceOnUse"
        >
            <stop offset=".053" stop-color="#75fff6" />
            <stop offset=".511" stop-color="#00c7d1" />
            <stop offset=".96" stop-color="#0096ad" />
        </linearGradient>
        <linearGradient
            id="i"
            x1="15.014"
            x2="12.787"
            y1="22"
            y2="18.875"
            gradientUnits="userSpaceOnUse"
        >
            <stop offset=".26" stop-color="#0e5a5d" />
            <stop offset=".536" stop-color="#126c6b" stop-opacity=".688" />
            <stop offset=".968" stop-color="#1c948a" stop-opacity="0" />
        </linearGradient>
    </defs>
</svg>`;
